import ProductPage from './Page';

// const ProductPage = loadable(() => import('./Page'))
export default ProductPage;
